import { useIntl } from 'react-intl';

import type { OrderAppDeliveryMode } from '@/graphql/orderApp/api';
import type { Maybe } from '@/lib/types';
import * as OM from '@/messages/order';

export const useTranslation = () => {
  const { formatMessage } = useIntl();

  const deliveryModeTitleTranslation = (
    deliveryMode: Maybe<OrderAppDeliveryMode>,
  ) => {
    let deliveryModeTitle = '';
    if (!deliveryMode) return deliveryModeTitle;
    switch (deliveryMode) {
      case 'HOME_DELIVERY':
        deliveryModeTitle = formatMessage(OM.orderMessages.homeDelivery);
        break;
      case 'BOUTIQUE_PICKUP':
        deliveryModeTitle = formatMessage(OM.orderMessages.boutiquePickUp);
        break;
    }
    return deliveryModeTitle;
  };

  return { deliveryModeTitleTranslation };
};
